<template>
  <div
    class="flex flex-col h-full bg-white shadow-sm flex-grow lg:border-l lg:border-[#BB80E7]"
    :style="{ borderColor: chatStore?.primaryColor }"
  >
    <div
      class="hidden lg:block font-bold p-2 text-center text-base sm:text-lg text-black border-b-2 border-gray-200"
    >
      AI Assistant
    </div>

    <div ref="chatMessages" class="chat-messages flex-grow p-2">
      <ChatMessage
        v-for="(msg, index) in chatStore.messages"
        :key="index"
        :message="msg"
        :isSpeakText="
          speakLatestAnswer && index === chatStore.messages.length - 1
        "
        @playMessage="startTyping"
        @stopMessage="playVideo"
      />
      <div
        class="p-4 mx-2 rounded-xl mb-5 max-w-[95%] flex justify-center items-center bg-gray-200 text-black self-start rounded-bl-none w-full"
        v-if="chatStore.loading"
      >
        <LoaderDots />
      </div>
    </div>
    <div
      class="flex w-full justify-center items-center gap-2 p-2 border-t border-gray-200 bg-white"
    >
      <InputBox
        @sendMessage="sendMessage"
        @clearSpeakingStatus="clearSpeakingStatus"
        :speechText="speechText"
      />
      <!-- <AudioRecorder
        @pauseVideo="startTyping"
        @resumeVideo="playVideo"
        @speechText="speechTextProcess"
      /> -->
    </div>
  </div>
</template>

<script>
import ChatMessage from "./ChatMessage.vue";
import InputBox from "./InputBox.vue";
import LoaderDots from "./LoaderDots.vue";
import useChatbotStore from "../store/chatbot";
// import AudioRecorder from "./AudioRecorder.vue";

export default {
  components: {
    ChatMessage,
    InputBox,
    LoaderDots,
    // AudioRecorder,
  },
  props: {
    answer: {
      type: String,
    },
  },
  data() {
    return {
      speechText: "",
      speakLatestAnswer: false,
      chatStore: useChatbotStore(), // Use the store in the data option

      silentAudio: null,
      isAudioUnlocked: false,
    };
  },
  methods: {
    startTyping() {
      this.$emit("typingStarted"); // Emit an event to notify typing has started
    },
    speechTextProcess(text) {
      this.speakLatestAnswer = false;
      this.speechText = text;
      this.chatStore.setMessage({ sender: "user", text, type: "text" });
      this.$emit("newQuestion", text); // Emit new question for API processing
    },
    playVideo() {
      this.$emit("resumeVideo");
    },
    sendMessage(text) {
      this.speakLatestAnswer = false;
      this.chatStore.setMessage({ sender: "user", text, type: "text" });
      this.$emit("newQuestion", text); // Emit new question for API processing
    },
    clearSpeakingStatus() {
      this.speakLatestAnswer = false;
    },
    scrollToBottom() {
      // Scroll to the bottom of the chat
      if (this.$refs.chatMessages) {
        this.$refs.chatMessages.scrollTop =
          this.$refs.chatMessages.scrollHeight;
      }
    },
  },
  watch: {
    answer: {
      immediate: true,
      handler(val) {
        setTimeout(() => {
          // this.chatStore.setMessage({ sender: "bot", text: val, type: "text" });
          if (this.speechText.trim()) {
            this.speakLatestAnswer = true;
            this.chatStore.setMessage(
              {
                sender: "bot",
                text: val,
                type: "text",
              },
              true
            );
          } else {
            this.chatStore.setMessage({
              sender: "bot",
              text: val,
              type: "text",
            });
          }
          this.speechText = "";
        }, 100);
      },
    },
  },
  updated() {
    // Automatically scroll to the bottom when the component updates
    this.scrollToBottom();
  },
};
</script>

<style scoped>
.chat-messages {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
  background-color: #f4f2ff;
  display: flex;
  flex-direction: column;
  max-height: 90%;
}
</style>
